const toIdString = (value) => (value == null ? '' : `${value}`);

const round4 = (value) => {
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return 0;
  return Math.round(numeric * 1e4) / 1e4;
};

const pointSignature = (point) => {
  if (!Array.isArray(point) || point.length < 2) return '';
  return `${round4(point[0])},${round4(point[1])}`;
};

export const buildEntitySelectionFocusKey = ({
  enabled = false,
  primaryId = null,
  selectedIds = [],
} = {}) => {
  if (!enabled || primaryId == null) return null;
  const scopedIds = Array.isArray(selectedIds)
    ? selectedIds.filter((id) => id != null).map((id) => `${id}`)
    : [];
  return `${toIdString(primaryId)}|${scopedIds.join('|')}`;
};

export const buildTourGeometryFocusKey = ({
  viewTour = null,
  routePoints = [],
  stopsSignature = '',
} = {}) => {
  if (!viewTour) return null;
  const routeHead = routePoints[0] || null;
  const routeTail = routePoints.length ? routePoints[routePoints.length - 1] : null;
  return [
    `${viewTour?.id ?? 'tour'}`,
    `${routePoints.length}`,
    routeHead ? pointSignature(routeHead) : '',
    routeTail ? pointSignature(routeTail) : '',
    stopsSignature || '',
  ].join('|');
};

export default buildTourGeometryFocusKey;
